<template>
    <!-- Detail Project starts -->
    <section id="blog" class="details-project bg-light-gray text-left" @keydown.esc="backMethods">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <!-- Project List Inner -->
                    <div class="blog-listing-inner heading-space-half">
                        <div class="image">
                            <img src="@/assets/img/lean-experimentation/GoPay-1110x450.png" :alt="$t('category_lean.project_5_title')">
                        </div>
                    </div>
                </div>
                <!-- Project Left Listing -->
                <div class="col-lg-8 col-md-7">
                    <div class="blog-box heading-space-half m-md-0">
                        <!-- Project List Inner -->
                        <div class="blog-listing-inner news_item wow fadeIn" data-wow-delay="300ms">
                            <div class="news_desc">
                                <h3 class="pb-4 font-weight-normal font-primary text-uppercase" v-html="$t('category_lean.project_5_title_content')">
                                </h3>
                                <div class="content-editor" v-html="$t('category_lean.project_5_detail_content_1')"></div>

                                <p class="pb-4">
                                    <ul>
                                        <li class="ml-md-4">
                                            <div class="left">
                                                <img src="@/assets/logos/chevron-right-icon-36x36.png" class="icon-kopernik">
                                            </div>
                                            <div v-html="$t('category_lean.project_5_list_item_1_detail')"></div>
                                        </li>
                                        <li class="ml-md-4">
                                            <div class="left">
                                                <img src="@/assets/logos/chevron-right-icon-36x36.png" class="icon-kopernik">
                                            </div>
                                            <div v-html="$t('category_lean.project_5_list_item_2_detail')"></div>
                                        </li>
                                        <li class="ml-md-4">
                                            <div class="left">
                                                <img src="@/assets/logos/chevron-right-icon-36x36.png" class="icon-kopernik">
                                            </div>
                                            <div v-html="$t('category_lean.project_5_list_item_3_detail')"></div>
                                        </li>
                                    </ul>
                                </p>

                                <div class="content-editor" v-html="$t('category_lean.project_5_detail_content_2')"></div>
                            </div>
                            <!-- Button Close -->
                            <div class="wow fadeIn" data-wow-delay="600ms">
                                <span class="close-btn-bottom1 kopernik">
                                    <a @click="$router.go(-1)">
                                        <i class="fa fa-arrow-left fa-2x"></i>
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Project Widgets -->
                <div class="col-lg-4 col-md-5">
                    <div class="text-left">
                        <!-- Categories -->
                        <div class="widget heading-space-half wow fadeIn" data-wow-delay="400ms">
                            <h5 class="color-black font-weight-600 text-uppercase font-primary">
                                {{ $t('category_lean.category') }}
                            </h5>
                            <div>
                                <div class="categories-name">
                                    <p class="font-16 color-grey">
                                        <img src="@/assets/logos/chevron-right-icon-36x36.png" class="icon-kopernik"> {{ $t('category_lean.category_partnership') }}
                                    </p>
                                </div>
                                <div class="categories-name">
                                    <p class="font-16 color-grey">
                                        <img src="@/assets/logos/chevron-right-icon-36x36.png" class="icon-kopernik"> {{ $t('category_lean.category_research') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- Call Out Box -->
                        <div class="widget-parallax heading-space-half mb-0 parallax-setting parallaxie position-relative wow fadeIn" data-wow-delay="500ms">
                            <div class="bg-overlay bg-kopernik2 opacity-7"></div>
                            <div class="search-box position-relative bg-change">
                                <h5 class="color-white font-weight-600 text-capitalize font-primary mb-3">
                                    {{ $t('category_lean.project_5_call_out_1') }}
                                </h5>
                                <p class="font-secondary color-white text-white font-16 font-weight-normal mb-4">
                                    <b>{{ $t('category_lean.project_5_call_out_2') }}</b> 
                                        <a class="color-link-kopernik-custom" href="https://money.kompas.com/read/2020/12/07/155607226/survei-kopernik-generasi-milenial-paling-banyak-donasi-digital-di-masa-pandemi?page=all" target="_blank">{{ $t('category_lean.project_5_call_out_3') }}</a>
                                    <br>
                                    <b>{{ $t('category_lean.project_5_call_out_4') }}</b> 
                                        <a class="color-link-kopernik-custom" href="https://id.techinasia.com/donasi-digital-naik-72-persen" target="_blank">{{ $t('category_lean.project_5_call_out_5') }}</a> 
                                    <br>
                                    <b>{{ $t('category_lean.project_5_call_out_6') }}</b> 
                                        <a class="color-link-kopernik-custom" href="https://www.thejakartapost.com/academia/2021/03/05/digital-donations---new-potential-to-accelerate-philanthropy-.html" target="_blank">{{ $t('category_lean.project_5_call_out_7') }}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- Detail Project ends -->
</template>

<script>
export default {
    name: 'Project 5',
    methods: {
        backMethods() {
            this.$router.go(-1)
        }
    }
}
</script>